import { TextFieldContainer } from '@/components/inputs/TextFieldContainer'
import { DateFieldContainer } from '@/components/inputs/DateFieldContainer'
import type { BusinessInfoEditorViewModel } from '@/features/tax-profile/business-profiles/BusinessInfoEditorViewModel'
import { FormFieldGroup } from '@/components/Form'
import { observer } from 'mobx-react-lite'
import { masks } from '@/utils/input-mask-util'

export interface BusinessInfoEditorProps {
  vm: BusinessInfoEditorViewModel
  testId?: string
}

/**
 * Form fields for editing business information.
 */
export const BusinessInfoEditor = observer(function BusinessInfoEditor({
  vm,
  testId,
}: BusinessInfoEditorProps) {
  return (
    <>
      <FormFieldGroup>
        <TextFieldContainer
          model={vm}
          field="businessName"
          label="Business name"
          testId={testId ? `${testId}-business-name-input` : undefined}
        />
      </FormFieldGroup>
      <FormFieldGroup stackWhenCompact>
        <DateFieldContainer
          model={vm}
          field="dateOfIncorporation"
          label="Date of incorporation"
          testId={testId ? `${testId}-date-of-incorporation-input` : undefined}
        />
        <TextFieldContainer
          model={vm}
          field="employerIdentificationNumber"
          label="Employer identification number (EIN)"
          placeholder="XX-XXXXXXX"
          mask={masks.ein}
          data-private
          testId={testId ? `${testId}-ein-input` : undefined}
        />
      </FormFieldGroup>
    </>
  )
})
